import { Link } from 'react-router'
import { ContentCopy } from '@mui/icons-material'
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material'

import { getFormattedDateTime } from '../../utils/helpers'
import useClipboard from '../../utils/hooks/useClipboard'

import useStyles from './index.styles'
import OrderField from './order-field'
import OrderTimeline from './order-timeline'

const ReturnInfo = ({ orderDetail }: { orderDetail: IReturnDetail }) => {
  const classes = useStyles
  const { clickToCopy } = useClipboard()
  const events = orderDetail.events || []
  const trackingUpdatedAt = events[events.length - 1]?.eventTime || orderDetail?.trackingNumberTs

  return (
    <Grid
      container={true}
      sx={{
        gap: 2,
      }}
    >
      <Grid size={2.9}>
        <OrderTimeline events={orderDetail.events} orderType="return" />
      </Grid>
      <Grid size="auto">
        <Divider orientation="vertical" variant="middle" />
      </Grid>
      <Grid
        container={true}
        spacing={2}
        size={3}
        sx={{
          alignContent: 'flex-start',
        }}
      >
        <Grid size={12}>
          <Grid
            container={true}
            size={12}
            sx={{
              justifyItems: 'center',
            }}
          >
            <Grid size={12}>
              <Typography variant="overline" sx={classes.summaryFieldTitle}>
                Tracking Number
              </Typography>
            </Grid>

            <Grid container={true} size={12}>
              <Typography variant="body1">
                {orderDetail.trackingNumber && orderDetail.trackingNumber.startsWith('1Z') && (
                  <Link to={`https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=${orderDetail.trackingNumber}`} target="_blank">
                    {orderDetail.trackingNumber}
                  </Link>
                )}
                {orderDetail.trackingNumber && !orderDetail.trackingNumber.startsWith('1Z') && orderDetail.trackingNumber}
                {!orderDetail.trackingNumber && '-'}
              </Typography>

              {orderDetail.trackingNumber && (
                <Tooltip title="Copy tracking number to clipboard" arrow={true} placement="top">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation()
                      clickToCopy(orderDetail.trackingNumber ?? '')
                    }}
                    sx={classes.copyIconButton}
                    aria-label="Copy tracking number to clipboard"
                  >
                    <ContentCopy color="primary" sx={classes.copyIcon} />
                  </IconButton>
                </Tooltip>
              )}
              {trackingUpdatedAt && (
                <Grid size={12}>
                  <Typography variant="caption">Updated {getFormattedDateTime(trackingUpdatedAt)}</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid size={12}>
          <OrderField
            xs={12}
            label="Return Reason + Notes"
            value={
              <Typography>
                {orderDetail.returnReason}
                <br />
                {orderDetail.returnNotes}
              </Typography>
            }
          />
        </Grid>
      </Grid>
      <Grid
        container={true}
        spacing={2}
        size="grow"
        sx={{
          alignContent: 'flex-start',
        }}
      >
        <OrderField xs={12} label="RMA #" value={orderDetail.rmaNumber} />
        <OrderField xs={12} label="Created" value={getFormattedDateTime(orderDetail.createdAt)} />
        <OrderField xs={12} label="Last Updated" value={orderDetail.updatedAt ? getFormattedDateTime(orderDetail.updatedAt) : ''} />
      </Grid>
    </Grid>
  )
}

export default ReturnInfo
